import { Supabase } from '@firmable/contracts';
import { DownloadStatus } from '@firmable/contracts/src/Supabase/Inngest';

export const statusKeys: Record<string, DownloadStatus[]> = {
  Completed: ['REQUEST_COMPELETED', 'DOWNLOAD_FILE_GENERATED'],
  Failed: ['REQUEST_FAILED'],
  'Insufficient credits': ['INSUFFICIENT_CREDITS'],
  'In progress': ['CREDIT_VALIDATION_COMPLETED', 'CREDIT_VALIDATION_INPROGRESS'],
  'Request accepted': ['REQUEST_ACCEPTED'],
  'Partially completed': ['REQUEST_PARTIALLY_COMPLETED'],
  'No profiles to download': ['NO_PROFILES_TO_DOWNLOAD'],
};

const TypeTextToShow: Record<Supabase.Inngest.DownloadType, string> = {
  DOWNLOAD: 'Download',
  HS_INTEGRATION: 'Push to HubSpot',
  SF_INTEGRATION: 'Push to Salesforce',
  ENRICH_DOWNLOAD: 'Download (from uploads)',
  ENRICH_HS_INTEGRATION: 'Push to HubSpot (from uploads)',
  ENRICH_SF_INTEGRATION: 'Push to Salesforce (from uploads)',
  ENRICH_PIPEDRIVE_INTEGRATION: 'Push to Pipedrive (from uploads)',
  PIPEDRIVE_INTEGRATION: 'Push to Pipedrive',
  MSDYNAMICS365SALES_INTEGRATION: 'Push to MS Dynamics 365 Sales',
  ENRICH_MSDYNAMICS365SALES_INTEGRATION: 'Push to MS Dynamics 365 Sales (from uploads)',
  JOBADDER_INTEGRATION: 'Push to JobAdder',
  ENRICH_JOBADDER_INTEGRATION: 'Push to JobAdder (from uploads)',
  AGENT_CRM_DOWNLOAD: 'Download (from CRM agent)',
  AGENT_CRM_HS_INTEGRATION: 'Push to HubSpot (from CRM agent)',
  AGENT_CRM_SF_INTEGRATION: 'Push to Salesforce (from CRM agent)',
  AGENT_SIGNAL_HS_CRM_ACTION: 'Push to HubSpot (from signal agent)',
  AGENT_SIGNAL_SF_CRM_ACTION: 'Push to Salesforce (from signal agent)',
  WH_ENRICHMENT: 'Push to Webhook',
};

export type CRMIntegrationType = Exclude<Supabase.Inngest.DownloadType, 'DOWNLOAD' | 'ENRICH_DOWNLOAD'>;

const CRMIntegrationType: CRMIntegrationType[] = [
  'HS_INTEGRATION',
  'SF_INTEGRATION',
  'PIPEDRIVE_INTEGRATION',
  'MSDYNAMICS365SALES_INTEGRATION',
  'ENRICH_MSDYNAMICS365SALES_INTEGRATION',
  'ENRICH_HS_INTEGRATION',
  'ENRICH_SF_INTEGRATION',
  'ENRICH_PIPEDRIVE_INTEGRATION',
  'JOBADDER_INTEGRATION',
  'ENRICH_JOBADDER_INTEGRATION',
  'AGENT_CRM_HS_INTEGRATION',
  'AGENT_CRM_SF_INTEGRATION',
  'AGENT_SIGNAL_HS_CRM_ACTION',
  'AGENT_SIGNAL_SF_CRM_ACTION',
];

export const Download = {
  TypeTextToShow,
  statusKeys,
  CRMIntegrationType,
};
